import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignup } from '../auth/signup/SignupContext';
import SignupModal from '../auth/signup/SignupModal';
import { useProfileStore } from '../../state/profileStore';
import { useMatrixStore } from '../../state/matrixStore';
import { useModalStore } from '../../state/modalStore';
import ChatCenter from '../chat/chatCenter';

const NavButton = ({ icon: Icon, description, onClick, isActive }) => (
  <div className="relative group">
    <button
      onClick={onClick}
      className={`p-3 rounded-lg transition-all duration-300 transform hover:scale-105 hover:bg-[#00aef7] hover:text-white ${
        isActive
          ? 'bg-[#00aef7] text-white'
          : 'bg-white text-[#00aef7]'
      }`}
    >
      <Icon />
    </button>
    <div className="absolute hidden group-hover:block w-48 p-2 bg-gray-800 text-white text-sm rounded-md shadow-lg -bottom-12 left-0 z-50">
      {description}
    </div>
  </div>
);



const ProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-9 h-9"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" />
  </svg>
);


const CompanyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-9 h-9"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M80-120v-720h400v160h400v560H80Zm80-80h240v-80H160v80Zm0-160h240v-80H160v80Zm0-160h240v-80H160v80Zm0-160h240v-80H160v80Zm320 480h320v-400H480v400Zm80-240v-80h160v80H560Zm0 160v-80h160v80H560Z" />
  </svg>
);
const TeamsIcon = ({ isActive }) => (
<svg
  className="w-9 h-9"
  viewBox="0 -960 960 960"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <g transform="translate(0 180)">
  <path d="m 438.32296,-640 q -66,0 -113,-47 -47,-47 -47,-113 0,-66 47,-113 47,-47 113,-47 66,0 113,47 47,47 47,113 0,66 -47,113 -47,47 -113,47 z m -320,320 v -112 q 0,-34 17.5,-62.5 17.5,-28.5 46.5,-43.5 62,-31 126,-46.5 64,-15.5 130,-15.5 66,0 130,15.5 64,15.5 126,46.5 29,15 46.5,43.5 17.5,28.5 17.5,62.5 v 112 z m 80,-80 h 480 v -32 q 0,-11 -5.5,-20 -5.5,-9 -14.5,-14 -54,-27 -109,-40.5 -55,-13.5 -111,-13.5 -56,0 -111,13.5 -55,13.5 -109,40.5 -9,5 -14.5,14 -5.5,9 -5.5,20 z m 240,-320 q 33,0 56.5,-23.5 23.5,-23.5 23.5,-56.5 0,-33 -23.5,-56.5 -23.5,-23.5 -56.5,-23.5 -33,0 -56.5,23.5 -23.5,23.5 -23.5,56.5 0,33 23.5,56.5 23.5,23.5 56.5,23.5 z" />
  <path d="m 148.49481,-748.60774 c -20.41779,0 -37.88275,7.93264 -52.422749,23.86194 -14.53984,15.92932 -21.82466,35.70122 -21.82466,59.24903 0,22.85521 7.28482,42.40514 21.82466,58.68089 14.539999,16.2756 32.004959,24.43007 52.422749,24.43007 21.0365,0 38.69978,-8.15447 52.93027,-24.43007 14.23051,-16.27575 21.31712,-35.82568 21.31712,-58.68089 0,-23.54781 -7.08661,-43.31971 -21.31712,-59.24903 -14.23049,-15.9293 -31.89377,-23.86194 -52.93027,-23.86194 z m 593.97923,0 c -20.41775,0 -37.88269,7.93264 -52.42276,23.86194 -14.53987,15.92932 -21.82464,35.70122 -21.82464,59.24903 0,22.85521 7.28477,42.40514 21.82464,58.68089 14.54007,16.2756 32.00501,24.43007 52.42276,24.43007 21.03653,0 38.6998,-8.15447 52.93033,-24.43007 14.23045,-16.27575 21.31709,-35.82568 21.31709,-58.68089 0,-23.54781 -7.08664,-43.31971 -21.31709,-59.24903 -14.23053,-15.9293 -31.8938,-23.86194 -52.93033,-23.86194 z m -593.97923,207.7774 c -44.54781,0 -80.449569,9.38274 -107.673245,28.08242 C 13.5979,-494.04826 0,-469.80685 0,-440.02584 v 65.41741 h 167.05665 v -67.52766 c 0,-17.31448 2.19456,-33.90478 6.52566,-49.83411 4.33107,-15.92931 10.76986,-31.23168 19.43193,-45.77595 -6.80589,-1.38518 -13.89252,-2.25092 -21.31714,-2.59723 -7.42459,-0.34628 -15.15895,-0.48696 -23.20229,-0.48696 z m 593.97923,0 c -7.42463,0 -14.70942,0.14068 -21.82466,0.48696 -7.11539,0.34631 -14.07619,1.21205 -20.88207,2.59723 8.04331,13.85168 14.10515,28.79153 18.12677,44.72084 4.02179,15.92944 6.0181,32.88213 6.0181,50.88922 v 67.52766 h 167.05665 v -65.41741 c 0,-30.47358 -13.59773,-54.93684 -40.82155,-73.29022 -27.22365,-18.35353 -63.12544,-27.51428 -107.67324,-27.51428 z" />
</g>
</svg>


);
const CustomersIcon = ({ isActive }) => (
<svg
  viewBox="0 -960 960 960"
  fill="currentColor"
  className="w-9 h-9"
  xmlns="http://www.w3.org/2000/svg"
>
  {/* nudge RIGHT: increase the first number (start with 25–40) */}
  <g transform="translate(30 0)">
    <path d="m 700.20488,-946.50527 c 0.32058,0.35033 0.64199,0.71366 0.98099,1.04621 0.34619,0.33961 0.9686,1.27917 1.17133,0.83855 0.30348,-0.65962 -0.99167,-1.12316 -1.58529,-1.54136 -0.18033,-0.12701 -0.38505,-0.21881 -0.56703,-0.3434 z m -338.48401,89.89459 c -0.36138,0.16629 -0.72527,0.34997 -1.08216,0.50713 -0.66797,0.38905 -1.56191,0.60992 -2.03251,1.22324 -0.38793,0.50559 1.40097,-0.11944 1.87812,-0.54172 0.42973,-0.3804 0.80943,-0.80448 1.23655,-1.18862 z m 381.72598,-62.86629 c -0.30077,0.19892 -0.58002,0.43674 -0.89313,0.62159 1.02598,-0.6607 0.0487,1.03635 0.89313,-0.62159 z m 7.10655,31.88136 c 0.89778,0.22961 1.50261,0.53362 3.16125,0.75204 0.28623,0.0377 -0.39506,-0.4311 -0.68017,-0.47651 -0.82081,-0.13076 -1.65596,-0.18702 -2.48108,-0.27553 z m 8.79833,39.75189 c -0.34405,0.35162 -0.68967,0.69951 -1.02757,1.05686 -0.2687,0.28416 0.38672,-0.32345 0.85586,-0.77335 0.0498,-0.0983 0.12187,-0.18519 0.17171,-0.28351 z m -100.16946,162.73075 c -0.78472,1.89049 -0.9832,2.07878 -0.29017,1.43886 -0.0591,0.36334 -0.26359,0.73355 -0.21297,1.09812 0.0272,0.19642 0.13319,-0.4026 0.26754,-0.54838 0.0408,-0.0443 0.077,0.0849 0.11311,0.1331 0.0521,-0.71629 0.10201,-1.40476 0.12246,-2.12169 z m -626.041935,186.02506 104.951615,427.299849 233.07264,-57.246329 -13.82707,-56.29554 290.51569,8.93087 286.91088,-173.44205 -9.54105,-38.84544 c -8.58692,-34.96074 -26.84169,-60.37144 -54.74901,-76.17075 -27.90732,-15.79932 -58.0394,-19.69325 -90.41048,-11.7424 l -77.69088,19.08211 c -5.72462,-23.30719 -17.58176,-43.06503 -35.62441,-59.22781 -18.04266,-16.16282 -38.70477,-25.45582 -61.97789,-27.97731 l -248.97621,-28.46548 c -4.20254,-0.34075 -8.73837,-0.44414 -13.50885,-0.30212 -4.77049,0.14199 -9.40286,0.78099 -13.93479,1.89411 z m 96.772995,58.60877 77.69088,-19.08211 66.78739,271.91809 -77.69088,19.08211 z m 155.38176,-38.16422 62.13754,-15.26196 247.74764,27.72142 c 6.30383,0.51112 12.39313,3.44545 18.19152,8.88609 5.79842,5.44058 9.56081,11.7407 11.31,18.86233 -29.29299,6.50834 -51.58955,10.62785 -66.95729,12.34297 -15.36772,1.71515 -28.96357,2.26027 -40.76483,1.72645 l -85.10623,-6.85079 -2.79772,80.9733 97.75921,7.92625 c 11.96027,1.18126 23.24112,1.12425 33.9179,-0.12518 10.67678,-1.24942 24.73264,-3.9831 42.21301,-8.27656 l 196.19982,-48.18978 c 7.76905,-1.9082 15.22681,-1.52496 22.41095,1.17262 7.18409,2.69756 13.15192,6.60034 17.82015,11.63204 l -213.52867,128.62935 -288.07719,-7.51862 z" />
    <path d="m 493.22275,-863.7805 c -23.65982,0 -43.93261,8.67566 -60.78126,26.01562 -16.84865,17.33996 -25.23437,38.15024 -25.23437,62.5 0,24.34974 8.38572,45.16005 25.23437,62.5 16.84865,17.33998 37.12144,26.01562 60.78126,26.01562 23.6598,0 43.9326,-8.67564 60.78124,-26.01562 16.84867,-17.33995 25.23438,-38.15026 25.23438,-62.5 0,-24.34976 -8.38571,-45.16004 -25.23438,-62.5 -16.84864,-17.33996 -37.12144,-26.01562 -60.78124,-26.01562 z m 0,44.21874 c 11.8299,0 21.9663,4.3769 30.39062,13.04688 8.42434,8.66999 12.65625,19.07511 12.65625,31.25 0,12.17487 -4.23191,22.58002 -12.65625,31.25 -2.32968,2.39762 -4.75362,4.51544 -7.34375,6.25 -6.77599,4.5378 -14.48843,6.79688 -23.04687,6.79688 -11.82991,0 -21.96629,-4.37689 -30.39063,-13.04688 -8.42432,-8.66998 -12.57813,-19.07513 -12.57813,-31.25 1e-5,-12.17489 4.15381,-22.58001 12.57813,-31.25 8.42434,-8.66998 18.56072,-13.04688 30.39063,-13.04688 z m 0,155 c -23.65982,0 -46.97903,2.87526 -69.92188,8.59376 -22.94285,5.7185 -45.5085,14.26612 -67.73438,25.70312 -10.39597,5.53402 -18.72654,13.54785 -25,24.0625 -6.27343,10.51467 -9.375,22.06556 -9.375,34.60938 v 27.89062 c 19.44674,2.59142 41.53102,7.7998 23.82813,-11.79688 0.1437,0.12463 0.30411,0.18657 0.46875,0.3125 3.51212,3.20482 7.006,6.52527 9.60938,10.54688 2.88626,3.80933 5.74285,7.70271 7.8125,12.03125 0.47592,1.09808 0.29468,0.76437 0.46874,1.09375 0.64322,0.52209 1.31396,1.03574 1.95313,1.5625 -1.64014,-1.10321 2.24741,1.83569 3.67187,2.96875 0.58879,0.46834 1.12715,0.94119 1.71876,1.40625 2.3546,1.9012 4.72353,3.88132 6.79687,6.09375 3.10392,3.31214 5.64455,6.61518 7.65625,9.84375 H 665.33212 V -571.593 c 0,-12.54382 -3.1797,-24.09471 -9.45313,-34.60938 -6.27342,-10.51465 -14.60403,-18.52848 -25,-24.0625 -22.22586,-11.437 -44.79152,-19.98462 -67.73437,-25.70312 -22.94286,-5.7185 -46.26207,-8.59376 -69.92187,-8.59376 z m 0,44.21876 c 20.07497,0 39.97098,2.51936 59.6875,7.5 19.71652,4.98062 39.23571,12.46062 58.59374,22.42187 3.22633,1.84469 5.84085,4.41395 7.8125,7.73437 1.97166,3.32042 2.96876,7.03546 2.96876,11.09376 v 17.65624 h -258.125 V -571.593 c -1e-5,-4.0583 0.9971,-7.77334 2.96874,-11.09376 1.97166,-3.32042 4.58617,-5.88968 7.8125,-7.73437 19.35803,-9.96125 38.87724,-17.44125 58.59376,-22.42187 19.71652,-4.98064 39.61252,-7.5 59.6875,-7.5 z" />
    <path d="m 206.65987,-667.60631 c -23.65984,0 -43.91409,-8.66999 -60.76275,-26.00999 -16.84867,-17.33997 -25.27301,-38.18486 -25.27301,-62.53462 0,-24.34978 8.42434,-45.19466 25.27301,-62.53464 16.84866,-17.33998 37.10291,-26.00998 60.76275,-26.00998 23.65983,0 43.91409,8.67 60.76275,26.00998 16.84868,17.33998 25.27301,38.18486 25.27301,62.53464 0,24.34976 -8.42433,45.19465 -25.27301,62.53462 -16.84866,17.34 -37.10292,26.00999 -60.76275,26.00999 z M 34.588351,-490.51708 v -61.98123 c 0,-12.54383 3.13671,-24.07307 9.41015,-34.58775 6.27346,-10.51466 14.60817,-18.53903 25.00416,-24.07306 22.225902,-11.43701 44.810289,-20.01477 67.753159,-25.73328 22.94287,-5.7185 46.24421,-8.57776 69.90405,-8.57776 23.65983,0 46.96118,2.85926 69.90406,8.57776 22.94287,5.71851 45.52726,14.29627 67.75315,25.73328 10.39598,5.53403 18.73073,13.5584 25.00416,24.07306 6.27343,10.51468 9.41014,22.04392 9.41014,34.58775 v 61.98123 z m 43.017879,-44.27231 h 258.10728 v -17.70892 c 0,-4.0583 -0.98582,-7.74766 -2.95748,-11.06808 -1.97166,-3.32043 -4.57065,-5.90297 -7.79698,-7.74766 -19.35805,-9.96126 -38.89534,-17.43222 -58.61188,-22.41285 -19.71653,-4.98064 -39.6123,-7.47095 -59.6873,-7.47095 -20.075,0 -39.97077,2.49031 -59.68731,7.47095 -19.71653,4.98063 -39.25382,12.45159 -58.611857,22.41285 -3.22634,1.84469 -5.82533,4.42723 -7.796993,7.74766 -1.97165,3.32042 -2.95748,7.00978 -2.95748,11.06808 z m 129.05364,-177.08923 c 8.55845,0 16.22565,-2.2689 23.00165,-6.8067 2.59013,-1.73456 5.05004,-3.80067 7.37972,-6.19829 8.42435,-8.66999 12.63651,-19.09243 12.63651,-31.26731 0,-12.1749 -4.21216,-22.59732 -12.63651,-31.26732 -8.42433,-8.66999 -18.55145,-13.00499 -30.38137,-13.00499 -11.82992,0 -21.95703,4.335 -30.38138,13.00499 -8.42433,8.67 -12.6365,19.09242 -12.6365,31.26732 0,12.17488 4.21217,22.59732 12.6365,31.26731 8.42435,8.67 18.55146,13.00499 30.38138,13.00499 z" />
    <path d="m 734.20645,-781.30827 c -23.6598,0 -43.93262,8.59756 -60.78126,25.9375 -16.84863,17.33994 -25.3125,38.22839 -25.3125,62.57812 0,24.34971 8.46387,45.16006 25.3125,62.5 16.84864,17.33997 37.12146,26.01563 60.78126,26.01563 23.65977,0 43.8545,-8.67566 60.70312,-26.01563 16.84864,-17.33994 25.3125,-38.15029 25.3125,-62.5 0,-24.34973 -8.46386,-45.23818 -25.3125,-62.57812 -16.84862,-17.33994 -37.04335,-25.9375 -60.70312,-25.9375 z m 0,44.21875 c 11.82988,0 21.88817,4.37689 30.3125,13.04687 8.42433,8.66999 12.65624,19.07513 12.65624,31.25 0,12.17485 -4.23191,22.58002 -12.65624,31.25 -2.32968,2.39761 -4.75363,4.43732 -7.34376,6.17188 -6.77598,4.5378 -14.41031,6.875 -22.96874,6.875 -11.8299,0 -21.9663,-4.37689 -30.39063,-13.04688 -8.42431,-8.66998 -12.65625,-19.07515 -12.65625,-31.25 0,-12.17487 4.23194,-22.58001 12.65625,-31.25 8.42433,-8.66998 18.56073,-13.04687 30.39063,-13.04687 z m 0,155 c -23.6598,0 -46.97905,2.79714 -69.92188,8.51563 -22.94283,5.7185 -45.50852,14.34426 -67.73438,25.78124 -10.39595,5.53402 -18.72654,13.54787 -25,24.0625 -6.27342,10.51465 -9.45312,22.06557 -9.45312,34.60938 v 9.84375 c 0.46968,0.17771 0.939,0.36546 1.40625,0.54687 1.96921,0.66452 3.81049,1.50808 5.70313,2.34376 0.0316,-0.0229 0.13171,-0.13806 0.15624,-0.15626 4.12966,-2.99073 8.58804,-5.43798 13.20313,-7.57812 2.25511,-0.98884 4.50285,-1.99656 6.79687,-2.89062 5.74508,-2.23911 11.04056,-3.40919 15.85938,-3.75 0.23702,-3.41519 1.19131,-6.59133 2.89062,-9.45313 1.97166,-3.32043 4.50804,-5.88969 7.73438,-7.73437 19.358,-9.96125 38.95537,-17.44125 58.67188,-22.42188 19.7165,-4.98064 39.61254,-7.5 59.6875,-7.5 20.07494,0 39.97099,2.51936 59.6875,7.5 19.7165,4.98063 39.23573,12.46063 58.59374,22.42188 3.22633,1.84468 5.84086,4.41394 7.8125,7.73437 1.97166,3.32042 2.89063,7.03545 2.89063,11.09375 v 17.65625 H 634.36269 c 0.85545,6.92765 -1.80243, 14.62982 -8.82812,21.09375 3.1024,5.41908 -5.38741,14.52605 -14.29688,23.20312 h 295 v -61.95312 c 0,-12.54381 -3.10157,-24.09473 -9.375,-34.60938 -6.27341,-10.51463 -14.60404,-18.52848 -25,-24.0625 -22.22583,-11.43698 -44.86967,-20.06274 -67.8125,-25.78124 -22.94282,-5.71849 -46.18397,-8.51563 -69.84374,-8.51563 z m -158.82813,105.07813 c -1.31079,0.0933 -2.86292,0.54054 -4.6875,1.25 0.94563,0.40746 1.92173,0.8158 2.89063,1.17187 2.60385,0.88744 5.27371,1.76787 7.89062,2.65625 -0.64295,-3.34997 -2.41212,-5.34006 -6.09375,-5.07812 z" />
  </g>
</svg>



);

const PUBLIC_SITE = process.env.REACT_APP_PUBLIC_SITE_ORIGIN || 'https://www.ehandshake.com';

const Navbar = ({ onLoginClick }) => {
  const location = window.location.pathname;
  const { handleSignupClick, isSignupModalOpen, handleCloseSignup } = useSignup();
  const navigate = useNavigate();
  const profile = useProfileStore((s) => s.profile);

  const clearProfile = useProfileStore((s) => s.clearProfile);
  const isOpen = useMatrixStore(s => s.isOpen);
  const close  = useMatrixStore(s => s.close);



  const handleLogout = async () => {
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (_) {
      // ignore network errors; client state will still clear
    } finally {
      useModalStore.getState().closeAll();
      useMatrixStore.getState().reset();
      // 4) Clear local app state and go home
      clearProfile();
      navigate('/');
    }
  };



  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const m = params.get('modal');
    if (!m) return;

    if (m === 'signup') {
      // open the Signup modal (provided by useSignup)
      if (typeof handleSignupClick === 'function') {
        handleSignupClick();
      }
    } else if (m === 'login') {
      // open the Login modal (bubbled in via prop)
      if (typeof onLoginClick === 'function') {
        onLoginClick();
      }
    }

    // remove the query param so it won't re-open on route changes
    const url = new URL(window.location.href);
    url.searchParams.delete('modal');
    window.history.replaceState({}, '', url.toString());
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <nav className="fixed top-0 inset-x-0 z-40 bg-white/95 backdrop-blur shadow-sm">
        <div className="container mx-auto px-4 w-4/5">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
            <button
              onClick={() => navigate('/')}
              className="flex items-center"
              aria-label="eHandshake Home"
            >
              <img
                src="/images/brand/ehs-wordmark-blue.png"
                alt="eHandshake"
                className="h-9 w-auto"
              />
            </button>

            </div>
            <div className="flex items-center space-x-4">
              {profile ? (
                <>
                  <NavButton
                    icon={ProfileIcon}
                    description="View and manage your profile settings"
                    onClick={() => navigate('/profile')}
                    isActive={location.startsWith('/profile')}
                  />
                  <NavButton
                    icon={CompanyIcon}
                    description="View your company information"
                    isActive={location.startsWith('/company')}
                    onClick={() => {
                    const slug = (profile?.b_website || profile?.business?.b_website || '')
                      .toString()
                      .replace(/^https?:\/\//, '')
                      .replace(/\/$/, '');
                      if (!slug) return; // nothing to navigate to yet
                      navigate(`/company/${slug}`);
                    }}
                  />

                    <NavButton
                      icon={TeamsIcon}
                      description="View and manage your teams"
                      onClick={() => navigate('/teams')}
                      isActive={location === '/teams'}
                    />


                    <NavButton
                    icon={CustomersIcon}
                    description="View and manage your customers"
                    onClick={() => navigate('/customers')}
                    isActive={location === '/customers'}
                  />

                  <div className="flex flex-col items-start leading-tight space-y-1">
                    <button
                      onClick={() => navigate('/pricing')}
                      className="text-brand text-xs"
                    >
                      Pricing
                    </button>

                    <button
                      onClick={handleLogout}
                      className="text-brand text-xs"
                    >
                      Log Out
                    </button>
                  </div>


                </>
              ) : (
                <>
                  <a
                    href={`${PUBLIC_SITE}/search`}
                    className="p-2 rounded-lg text-[#00aef7] hover:bg-[#00aef7] hover:text-white transition-all duration-300"
                    title="Search the public directory"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                  </a>

                  <button
                    onClick={() => navigate('/pricing')}
                    className="text-brand text-xs"
                  >
                    Pricing
                  </button>

                  <button
                    onClick={handleSignupClick}
                    className="bg-brand text-white px-4 py-2 rounded hover:bg-brand-dark transition-colors"
                  >
                    Sign Up
                  </button>

                  <button 
                    onClick={onLoginClick}
                    className="text-gray-700 hover:text-brand transition-colors"
                  >
                    Log In
                  </button>
                </>

              )}
            </div>
          </div>
        </div>
      </nav>
      <div className="h-16" />

      <SignupModal 
        isOpen={isSignupModalOpen}
        onClose={handleCloseSignup}
      />
      <ChatCenter isOpen={isOpen} onClose={close} />
    </>
  );
};

export { Navbar };